class WishlistData extends HTMLElement {
    connectedCallback() {
        this.container = this.querySelector(".wishlist-viewed-grid");
        this.wishlistItems = JSON.parse(localStorage.getItem("wishlist_items")) || [];

        this.classList.toggle("wishlist-empty", !this.wishlistItems.length);

        this.loadProductData();
    }
    loadProductData() {
        if (!this.wishlistItems || !this.wishlistItems.length) return;
        this.wishlistItems.forEach((data) => {
            const handle = data.handle;
            fetch(`/products/${handle}?sections=product-card`)
            .then(response => response.json())
            .then(data => {
                const htmlString = data['product-card'];
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, "text/html");
                const productCard = doc.querySelector("product-card");
                if (productCard) {
                    this.container.innerHTML += productCard.outerHTML;
                }
            });
        });
    }
}

customElements.define('wishlist-data', WishlistData);